/* import __COLOCATED_TEMPLATE__ from './fake-collection.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();